import { useTranslation } from "../i18n/useTranslation";

interface TopBarProps {
  modeName: string;
  score: number;
  streak: number;
  roundNumber: number;
  totalRounds: number;
}

export function TopBar({
  modeName,
  score,
  streak,
  roundNumber,
  totalRounds,
}: TopBarProps) {
  const { t } = useTranslation();
  return (
    <header className="border-b border-[var(--color-line)] px-5 py-3 flex items-center justify-between">
      <span className="text-sm font-medium tracking-tight">{modeName}</span>
      <div className="flex items-center gap-4 font-mono text-[11px] tracking-[0.06em]">
        <span className="text-fg-2">
          <span className="text-fg-0">{score.toLocaleString()}</span>{" "}
          {t("common.score")}
        </span>
        {streak > 0 && (
          <span className="text-amber">
            {streak}× {t("common.streak")}
          </span>
        )}
        <span className="text-fg-3">
          {roundNumber}/{totalRounds}
        </span>
      </div>
    </header>
  );
}
